/**
 * CMS service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BlockType } from './blockType';
import { SimpleImage } from './simpleImage';
import { ElementTemplate } from './elementTemplate';
import { UrlValue } from './urlValue';
import { BlockTemplate } from './blockTemplate';
import { BlockElementV2Shared } from './blockElementV2Shared';


export interface PageContentBlockV2Shared { 
    id?: number;
    pageContentLineId?: number;
    parentId?: number;
    parentBlock?: boolean;
    staticBlock?: boolean;
    blockType?: BlockType;
    sortOrder?: number;
    title: string;
    metaUrl?: UrlValue;
    metaTitle?: string;
    metaImage?: SimpleImage;
    metaDescription?: string;
    staticFields?: Array<string>;
    template?: BlockTemplate;
    lgCol?: number;
    mdCol?: number;
    smCol?: number;
    xsCol?: number;
    additionalFields?: { [key: string]: any; };
    elementType?: PageContentBlockV2Shared.ElementTypeEnum;
    elementTemplate?: ElementTemplate;
    children?: Array<PageContentBlockV2Shared>;
    elements?: Array<BlockElementV2Shared>;
    rules?: { [key: string]: number; };
    temporary?: boolean;
    activeFrom?: Date;
    activeTo?: Date;
    regionIds?: Array<number>;
}
export namespace PageContentBlockV2Shared {
    export type ElementTypeEnum = 'ARTICLE' | 'FINANCIAL_ITEM' | 'PARTNER' | 'PARTNER_PRODUCT' | 'ITEM' | 'WIDGET' | 'CATEGORY' | 'TAG' | 'CUSTOM' | 'ITEM_CATEGORY';
    export const ElementTypeEnum = {
        ARTICLE: 'ARTICLE' as ElementTypeEnum,
        FINANCIAL_ITEM: 'FINANCIAL_ITEM' as ElementTypeEnum,
        PARTNER: 'PARTNER' as ElementTypeEnum,
        PARTNER_PRODUCT: 'PARTNER_PRODUCT' as ElementTypeEnum,
        ITEM: 'ITEM' as ElementTypeEnum,
        WIDGET: 'WIDGET' as ElementTypeEnum,
        CATEGORY: 'CATEGORY' as ElementTypeEnum,
        TAG: 'TAG' as ElementTypeEnum,
        CUSTOM: 'CUSTOM' as ElementTypeEnum,
        ITEM_CATEGORY: 'ITEM_CATEGORY' as ElementTypeEnum
    };
}


